<template>
    <div>
        <div class="main-internal-section width-full float-l">
            <div class="container">
                <template>
                    <div  class="row">
                        <div class="chat-bottom-section-web width-full float-l">
                            <div class="chat-web-left-section archived-chat-btm col-12 col-sm-12 col-md-12 col-lg-4 col-lg-4 float-l"> <!--left section-->
                                <div class="row">

                                    <div class="chat-btm-section-main add-user-main-section width-full float-l"> <!--middle section-->

                                        <div class="add-user-form width-full float-l mt_10 ">

                                            <div class="top-label-section archived-chat-main float-l width-full"> <!--top section-->
                                                <div v-if="isAdmin" class="form-group float-l width-full p_15">
                                                    <p class="select-box-label color-888888 heading-text-13 line-height-17 font-benton-book mb_0"> Search Customer </p>

                                                    <v-select v-model="customerId" name="customerId"
                                                            label="text" :filterable="false" :options="customerArr"
                                                            @search="onSearchCustomer"
                                                            placeholder="Select Customer" class="custom-ci-auto-search">
                                                        <template slot="no-options">
                                                            Search Customer...
                                                        </template>
                                                        <template slot="option" slot-scope="option">
                                                            <div class="d-center">
                                                                {{ option.text }}
                                                            </div>
                                                        </template>
                                                        <template slot="selected-option" slot-scope="option">
                                                            <div class="selected d-center">
                                                                {{ option.text }}
                                                            </div>
                                                        </template>
                                                    </v-select>
                                                    <!-- <span> <i class="fa fa-angle-down"></i> </span> -->
                                                </div>

                                                <div v-if="isAdmin" class="form-group float-l width-full p_15">
                                                    <p class="select-box-label color-888888 heading-text-13 line-height-17 font-benton-book mb_0"> Search User </p>

                                                    <v-select v-model="userId" name="userId"
                                                            label="text" :filterable="false" :options="userArr"
                                                            @search="onSearchUser"
                                                            placeholder="Select User" class="custom-ci-auto-search">
                                                        <template slot="no-options">
                                                            Search User...
                                                        </template>
                                                        <template slot="option" slot-scope="option">
                                                            <div class="d-center">
                                                                {{ option.text }}
                                                            </div>
                                                        </template>
                                                        <template slot="selected-option" slot-scope="option">
                                                            <div class="selected d-center">
                                                                {{ option.text }}
                                                            </div>
                                                        </template>
                                                    </v-select>
                                                    <!-- <span> <i class="fa fa-angle-down"></i> </span> -->
                                                </div>

                                                <div class="form-group float-l width-full p_15">
                                                    <p class="select-box-label color-888888 heading-text-13 line-height-17 font-benton-book mb_0"> From Date </p>
                                                    <date-picker class="form-control custom-select" placeholder="Select From Date" id="fromDate" name="From Date" v-model="fromDate" :config="options"></date-picker>
                                                    <div class="help is-danger">{{from_date_error_msg}}</div>
                                                    <span> <i class="hi-icon icon-chatcalendar"></i> </span>
                                                    <!-- v-validate="'required'" -->
                                                    <!-- <span v-show="errors.has('From Date')" class="help is-danger">{{ errors.first('From Date') }}</span> -->
                                                </div>

                                                <div class="form-group float-l width-full p_15">
                                                    <p class="select-box-label color-888888 heading-text-13 line-height-17 font-benton-book mb_0"> To Date </p>
                                                    <date-picker class="form-control custom-select" placeholder="Select To Date" id="toDate" name="To Date" v-model="toDate" :config="options"></date-picker>                                                
                                                    <div class="help is-danger">{{to_date_error_msg}}</div>
                                                    <span> <i class="hi-icon icon-chatcalendar"></i> </span>
                                                    <!-- v-validate="'required'" -->
                                                    <!-- <span v-show="errors.has('To Date')" class="help is-danger">{{ errors.first('To Date') }}</span> -->
                                                </div>

                                                <div class="archived-chat-btn float-l col-12 mt_15">
                                                    <button type="submit" class="btn btn-primary internal-large-btn" v-on:click="getArchivedChat()">
                                                        <span class="gradient"></span> Get Archived Chat
                                                    </button>

                                                    <button type="submit" class="btn btn-primary internal-large-btn internal-small-btn float-r" v-on:click="resetArchivedChat()">
                                                        <span class="gradient"></span> Reset
                                                    </button>
                                                </div>

                                                <div class="archived-chat-btn col-12 mt_15">
                                                    <!-- <div class="help is-danger">{{noConversationData}}</div> -->
                                                </div>

                                            </div> <!--top section-->

                                            <div class="btm-label-section btm-archived-section btm-archived-section-mobile float-l width-full bgcolor-f5f5f5"> <!--bottom section-->
                                            <chat-window v-if="isChatWindow" :chatWindowData="chatWindowArr" :flag="windowFlag" :fromId="fromId" :toId="toId" :date="date"></chat-window>
                                                <template v-else-if="resetFlag && archivedChatArr && archivedChatArr != ''">
                                                    <div class="archived-chat-detail-box float-l width-full" v-for="(archived, index) in archivedChatArr" :key="index"> <!--chat-detail-box-->
                                                        <template v-for="(archivedChat, index1) in archivedChatArr[index]">
                                                            <div :key="index1">
                                                                <p class="color-333333 heading-text-14 line-height-16 float-l font-benton-medium mb_0 archive" > {{archivedChat.ymd}} </p>
                                                                <a href="javascript:void(0)" v-on:click="showChatWindow(archivedChat.fromId, archivedChat.toId, archivedChat.ymd)" class="view-chat-link color-f5911e heading-text-14 line-height-16 float-r right font-benton-medium"> View Chat <i class="fa fa-angle-right"></i> </a>

                                                                <div class="archived-chat-listing float-l width-full">
                                                                    <div class="archived-chat-listing-left colpie-50 float-l">
                                                                        <h5 class="archive-chat-title"> Customer: </h5>
                                                                        <div class="btm-chat-info float-l width-full bgcolor-ffffff pt_10 pb_10">
                                                                            <p class="chat-description"> {{archivedChat.fromName}} </p>
                                                                            <p class="chat-description"> {{archivedChat.fromEmail}} </p>
                                                                        </div>
                                                                    </div>

                                                                    <div class="archived-chat-listing-right colpie-50 float-l">
                                                                        <h5 class="archive-chat-title"> Agent: </h5>
                                                                        <div class="btm-chat-info float-l width-full bgcolor-ffffff pt_10 pb_10">
                                                                            <p class="chat-description"> {{archivedChat.toName}} </p>
                                                                            <p class="chat-description"> {{archivedChat.toEmail}} </p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </template>
                                                    </div> <!--chat-detail-box-->
                                                </template>

                                            </div> <!--bottom section-->

                                        </div> 

                                    </div> <!--middle section-->	 
                                
                                </div>
                            </div> <!--left section-->

                            <div class="chat-web-right-section archived-chat-btm-main col-12 col-sm-8 col-md-12 col-lg-8 col-lg-8 float-l"> <!--right section-->
                                <div class="row">
                                    <chat-window v-if="isChatWindow" :chatWindowData="chatWindowArr" :flag="windowFlag" :fromId="fromId" :toId="toId" :date="date"></chat-window>
                                    <div v-else-if="resetFlag" class="btm-label-section btm-archived-section float-l width-full bgcolor-f5f5f5"> <!--bottom section-->
                                        <template v-if="archivedChatArr && archivedChatArr != ''">
                                            <div class="archived-chat-detail-box float-l width-full" v-for="(archived, mIndex) in archivedChatArr" :key="mIndex"> <!--chat-detail-box-->

                                                <template v-for="(archivedChat, mIndex1) in archivedChatArr[mIndex]" >
                                                    <div v-if="archivedChat.fromId == logingId || isAdmin" class="archived-chat-listing float-l colpie-100" :key="mIndex1">

                                                        <div class="archived-chat-listing-left colpie-23 float-l">
                                                            <h5 class="archive-chat-title"> Date: </h5>
                                                            <div class="btm-chat-info btm-chat-info-date float-l width-full bgcolor-ffffff pt_10 pb_10">
                                                                <p class="chat-description"> {{archivedChat.ymd}} </p>
                                                            </div>
                                                        </div>

                                                        <div class="archived-chat-listing-left colpie-30 float-l">
                                                            <h5 class="archive-chat-title"> Customer: </h5>
                                                            <div class="btm-chat-info float-l width-full bgcolor-ffffff pt_10 pb_10">
                                                                <p class="chat-description"> {{archivedChat.fromName}} </p>
                                                                <p class="chat-description"> {{archivedChat.fromEmail}} </p>
                                                            </div>
                                                        </div>

                                                        <div class="archived-chat-listing-right colpie-30 float-l">
                                                            <h5 class="archive-chat-title"> Agent: </h5>
                                                            <div class="btm-chat-info float-l width-full bgcolor-ffffff pt_10 pb_10">
                                                                <p class="chat-description"> {{archivedChat.toName}} </p>
                                                                <p class="chat-description"> {{archivedChat.toEmail}} </p>
                                                            </div>
                                                        </div>

                                                        <div class="archived-chat-listing-right archived-chat-view-web colpie-17 float-l">
                                                            <h5 class="archive-chat-title view-chat-title"> View Chat </h5>
                                                            <div class="btm-chat-info float-l width-full bgcolor-ffffff pt_10 pb_10">
                                                                <a href="javascript:void(0)" v-on:click="showChatWindow(archivedChat.fromId, archivedChat.toId, archivedChat.ymd)"> <span> <i class="fa fa-angle-right"></i> </span> </a>
                                                                <!-- <a v-if="archivedChat.fromId == logingId" href="javascript:void(0)" v-on:click="undoArchiveChatFromList(archivedChat.toId)"> <span> <i class="fa fa-undo" aria-hidden="true"></i> </span> </a> -->
                                                            </div>
                                                        </div>
                                                    </div>
                                                </template>

                                            </div> <!--chat-detail-box-->
                                        </template>
                                        <template v-else>
                                            <!-- <div class="help is-danger">{{noConversationData}}</div> -->
                                            <div class="no-data-found">{{noConversationData}}</div>
                                        </template>

                                    </div> <!--bottom section-->
                                </div>
                            </div> <!--right section-->

                        </div>

                    </div>
                </template>
                <!--<template v-else>
                    <template v-if="isRequestComplete">
                        <div class="col-md-12">
                            <div class="error-template">
                                <h1>
                                    Oops!</h1>
                                <h2>
                                    403 </h2>
                                <div class="error-details">
                                    Sorry!, You don't have permission to access this page.
                                </div>
                            </div>
                        </div>
                    </template>
                </template>-->
            </div> 
        </div>
        <app-footer></app-footer>
    </div>
</template>

<script>
    import Vue from "vue";
    import Footer from "@/components/partials/Footer";
    import {HTTP} from '../../http-common';
    import {commonMixins} from '../../mixins/commonMixins';
    import moment from 'moment';
    import EventBus from '../event-bus';
    import ChatWindow from "@/components/List/ChatWindow";
    
    /*// Import required dependencies 
    import 'bootstrap/dist/css/bootstrap.css';*/

    // Import this component
    import datePicker from 'vue-bootstrap-datetimepicker';
    // Import date picker css
    import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';

    Vue.use(datePicker);

    Vue.component("app-footer", Footer);
    Vue.component("chat-window", ChatWindow);
    export default {
        name: 'ArchivedChat',
        mixins: [commonMixins],
        data () {
            return {
                cantAccessPage: true,
                isRequestComplete: false,
                options: {
                    format: 'DD MMMM, YYYY',
                    useCurrent: false,
                },
                fromDate: '',
                toDate: '',
                customerId: '',
                customerArr: [],
                userId: '',
                userArr: [],
                archivedChatArr: [],
                chatWindowArr: [],
                isChatWindow: false,
                windowFlag: 'chatWindow',
                fromId: 0,
                toId: 0,
                date: '',
                from_date_error_msg: '',
                to_date_error_msg: '',
                resetFlag: true,
                noConversationData: '',
                isAdmin : false,

                unArchiveChatId : 0,
                logingId : 0,

                userUnarchiveArray : [],
                customerUnarchiveArray : [],
                displayUnarchiveArray : [],
                unArchiveChatArray : [],
            }
        },
        mounted: function() {
            var self = this;
            EventBus.$emit("headerMobileView", 'Archived Chat');
            self.getPermissions();
            $('select option:contains("archiveUserList")').prop('selected',true);
            self.checkIfLoginUserIsAdmin();
        },
        filters: {
            filtersGetName(value, value2) {

                let name1 = value2.split(" ");
                if(name1[1] && name1[1] != '') {
                    let getName = name1[0].charAt(0) + name1[1].charAt(0);
                    return getName.toUpperCase();
                }
                if(value) {
                    let name = value.charAt(0);
                    let splitData = value.split("@");
                    name += splitData[1].charAt(0);
                    return name.toUpperCase();
                }
            },
            filterCamelCase(data) {

                if (data && data != "") {
                    var value = data.replace(/_/g, " ");
                    var upp = value.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                        return letter.toUpperCase();
                    });
                    return upp;
                } else {
                    return data;
                }

            },
            filterDate(date) {
                if (date) {
                    var splitDate = date.split(",");
                    return splitDate[1];
                } else {
                    return '';
                }
            }
        },
        methods: {
            selectionChange : function (event) {
                let self = this;
                if (event.target.checked == true) {
                    self.unArchiveChatArray.push(event.target.value);
                } else {
                    var index = self.unArchiveChatArray.indexOf(event.target.value);
                    if (index > -1) {
                        self.unArchiveChatArray.splice(index, 1);
                    }
                }
            },

            onChangeSelect : function() {
                let self = this;

                $(document).ready(function(){
                    $('input:checkbox').removeAttr('checked');
                });

                self.unArchiveChatArray = [];

                var unArchiveSelect = document.getElementById("unarchiveSelect");
                var selectedList = unArchiveSelect.options[unArchiveSelect.selectedIndex].value;

                if (selectedList == "archiveCustomerList") {
                    self.displayUnarchiveArray = self.customerUnarchiveArray;
                } else if (selectedList == "archiveUserList") {
                    self.displayUnarchiveArray = self.userUnarchiveArray;
                }
            },

            undoArchiveChatFromList : function (unArchiveIds) {
                let self = this;

                var fields = {
                    id: unArchiveIds,
                };

                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("tkn")},
                };

                HTTP.post("un-archive-chat", fields, config)
                    .then(function (response) {
                        if (response.data.code == '200') {
/*
                            Swal.fire({
                                type: 'success',
                                title: 'Success',
                                showConfirmButton: false,
                                timer: 1500
                            });*/
                            self.getArchivedChat();

                            $('select option[value="archiveUserList"]').attr("selected",true);
                            $(document).ready(function(){
                                $('input:checkbox').removeAttr('checked');
                            });
                            self.unArchiveChatArray = [];
                        }

                    })
                    .catch(function (error) {
                        self.catchHandler(error, function () {});
                    });
            },
            checkIfLoginUserIsAdmin: function() {
                var self = this;
                let role = localStorage.getItem('role');
                self.logingId = JSON.parse(localStorage.getItem('user_obj'))['id'];
                if (role == "admin") {
                    self.isAdmin = true;
                }
            },
            resetArchivedChat: function() {
                var self = this;
                self.fromDate = '';
                self.toDate = '';
                self.customerId = '';
                self.userId = '';
                self.isChatWindow = false;
                self.from_date_error_msg = '';
                self.to_date_error_msg = '';
                self.resetFlag = false;
            },
            showChatWindow: function(getFromId, getToId, date) {
                var self = this;
                self.isChatWindow = true;
                self.windowFlag = 'detailWindow';
                self.fromId = getFromId;
                self.toId = getToId;
                self.date = date;
            },
            onSearchCustomer(search, loading) {
                var self = this;
                if (search.length > 2) {
                    loading(true);
                    self.loadCustomer(loading, search, this);
                }
            },
            onSearchUser(search, loading) {
                var self = this;
                if (search.length > 2) {
                    loading(true);
                    self.loadUser(loading, search, this);
                }
            },
            loadCustomer(loading, search, vm) {
                var self = this;
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("tkn")},
                    params: {
                        search: search
                    }
                };

                HTTP.get("search-customers", config)
                        .then(function (data) {
                            if (data.data.code == 200 && data.data.status == 'success') {
                                loading(false);
                                self.customerArr = data.data.content;
                            }
                        })
                        .catch(function (error) {
                            self.catchHandler(error, function () {});
                        })
            },
            loadUser(loading, search, vm) {
                var self = this;
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("tkn")},
                    params: {
                        search: search
                    }
                };

                HTTP.get("search-users", config)
                        .then(function (data) {
                            if (data.data.code == 200 && data.data.status == 'success') {
                                loading(false);
                                self.userArr = data.data.content;
                            }
                        })
                        .catch(function (error) {
                            self.catchHandler(error, function () {});
                        })
            },
            getArchivedChat: function() {

                var self = this;
                var error = false;
                self.from_date_error_msg = '';
                self.to_date_error_msg = '';
                self.noConversationData = '';

                if(self.userId == null) {
                    self.userId = '';
                }
                if(self.customerId == null) {
                    self.customerId = '';
                }

                if(!self.fromDate || self.fromDate == ''){
                    self.from_date_error_msg = 'The From Date field is required.';
                    error = true;
                }
                if(!self.fromDate || self.fromDate == ''){
                    self.to_date_error_msg = 'The To Date field is required.';
                    error = true;
                }
                /* this.$validator.validateAll().then((result) => {
                    if (result) { */
                    if (!error) {
                        var fields = {
                            fromId: self.userId.value,
                            toId: self.customerId.value,
                            flag: 'web',
                            fromdate: moment(self.fromDate).format('YYYY-MM-DD') + ' 00:00:00',
                            todate: moment(self.toDate).format('YYYY-MM-DD') + ' 23:59:59'
                        };
                        var config = {
                            headers: {Authorization: "Bearer " + localStorage.getItem("tkn")}
                        };
                        
                        self.showLoader();
                        HTTP.post("get-archive-chat", fields, config)
                                .then(function (data) {
                                    if (data.data.code == 200 && data.data.status == 'success') {
                                        //self.userArr = data.data.content;
                                        self.archivedChatArr = [];
                                        if(data.data.content != "") {
                                            if(!self.customerId.value || !self.userId.value) {
                                                self.archivedChatArr = data.data.content;
                                                self.isChatWindow = false;
                                                self.resetFlag = true;
                                            } else {
                                                self.isChatWindow = true;
                                                self.chatWindowArr = data.data.content;
                                            }
                                        } else {
                                            self.noConversationData = "No archived chat found!";
                                        }
                                    }
                                    self.hideLoader();
                                })
                                .catch(function (error) {
                                    self.hideLoader();
                                    self.catchHandler(error, function () {});
                                })
                    }
                    /* }
                }); */

            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .no-data-found {
        color: #c9202b;
        font-size: 14px;
        float: right;
        width: 100%;
        position: initial;
        padding-top: 5px;
        font-family: "BentonSansRegular", sans-serif;
    }
</style>


// WEBPACK FOOTER //
// src/components/List/ArchivedChat.vue